module.exports = __webpack_public_path__ + "img/editTopicDialog.6c92c23d.jpg";